import graphColors from './graphColors';

export default graphColors;
